import { calcDuration, type Duration } from 'cross-state';

export function sleep(duration: Duration): Promise<void> & Disposable {
    let timeoutId: ReturnType<typeof setTimeout>;

    return Object.assign(
        new Promise<void>((resolve) => {
            timeoutId = setTimeout(resolve, calcDuration(duration));
        }),
        {
            [Symbol.dispose]() {
                clearTimeout(timeoutId);
            },
        },
    );
}
